import { combineReducers } from 'redux'
import urls from './urls'
import uiFlags from './uiFlags'

export default combineReducers({
  urls,
  uiFlags,
})
